import { useContext, useState } from 'react'
import styled from 'styled-components'
import Button from '@app.components/Button'
import { ExamContext } from '@app.feature/exam/context/ExamContext'
import ExamAlert from '@app.feature/exam/gsat2024-2/components/alert/ExamAlert'
import useCreateQuestionKeywordForm, {
  CreateQuestionKeywordFormType,
} from '@app.feature/exam/gsat2024-2/hooks/examRestoredQuestions/useCreateQuestionKeywordForm'
import KeywordListDesktop from './KeywordList.desktop'

interface ItemKeywordsSectionProps {
  questionId: string
}

const ItemKeywordsSectionDesktop = ({
  questionId,
}: ItemKeywordsSectionProps) => {
  const [isOpenAlert, setIsOpenAlert] = useState<boolean>(false)
  const { handleCheckReservation } = useContext(ExamContext)
  const { createQuestionKeywordMutation, formMethods } =
    useCreateQuestionKeywordForm()

  const { handleSubmit, register, reset } = formMethods

  const handelAddQuestionKeyword = async (
    data: CreateQuestionKeywordFormType,
  ) => {
    handleCheckReservation({
      onReservated: async () => {
        const questionKeyword = data.questionKeyword.trim()
        if (questionKeyword !== '') {
          await createQuestionKeywordMutation({
            variables: {
              keyword: data.questionKeyword,
              questionId,
            },
            onError: (error) => {
              if (error.message === '이미 등록한 키워드입니다.') {
                setIsOpenAlert(() => true)
              }
            },
          })
        }
      },
    })
    reset()
  }

  const handleClickCloseAlert = () => {
    setIsOpenAlert(() => false)
  }

  return (
    <StyledWrapper>
      <p>복원 키워드</p>
      <KeywordListDesktop questionId={questionId} />
      <form
        className="add-keyword-layout"
        onSubmit={handleSubmit(handelAddQuestionKeyword)}
      >
        <input
          className="add-keyword-input"
          placeholder="키워드는 최대 8자 입력 가능합니다."
          maxLength={8}
          {...register('questionKeyword')}
        />
        <Button color="primary" className="add-keyword-button" type="submit">
          등록
        </Button>
      </form>
      {isOpenAlert && (
        <ExamAlert
          type="alert"
          message="이미 등록한 키워드입니다."
          onClickConfirm={handleClickCloseAlert}
        />
      )}
    </StyledWrapper>
  )
}

export default ItemKeywordsSectionDesktop

const StyledWrapper = styled.div`
  background-color: #fcfcfc;
  padding: 20px 24px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;

  > p {
    font-size: 16px;
    font-weight: bold;
    letter-spacing: -0.64px;
    color: #333;
    margin-bottom: 12px;
  }

  > .add-keyword-layout {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 20px;

    > .add-keyword-input {
      width: 100%;
      border-radius: 8px;
      border: solid 1px #cccccc;
      background-color: #fff;
      height: 50px;
      border-radius: 8px;
      padding-left: 16px;
      font-size: 16px;
      font-weight: 500;
      line-height: 1.63;
      letter-spacing: -0.64px;
      text-align: left;
      color: #333;

      &::placeholder {
        font-size: 16px;
        font-weight: 500;
        line-height: 1.63;
        letter-spacing: -0.64px;
        text-align: left;
        color: #999;
      }
    }

    > .add-keyword-button {
      min-width: max-content;
      height: 50px;
    }
  }
`
